var TemplateEditorModeManager = require('./template');

function StickerEditorModeManager () {
  this.type = 'sticker';

  this.disableList = [
    '#header #shr-buttons > a:not(.save)',
    '.tool-menu a[role="tab"][href="#tabLayouts"]',
    '.tool-menu a[role="tab"][href="#tabFavourites"]',
    '.tool-menu a[role="tab"][href="#tabImages"]',
    '.tool-menu a[role="tab"][href="#tabSearch"]',
    '.tool-content #tabAdmin input[name="search"]',
    '.tool-content a[data-toggle="accordion"][href="#accordionBackgrounds"]',
    '.tool-content #tabAdmin a[data-toggle="accordion"][href="#accordionAdminLayouts"]',
    '.tool-content #tabAdmin .btn-new-item',
    '.tool-content #tabAdmin a[data-toggle="accordion"][href="#accordionAdminBackgrounds"]'
  ];
}

StickerEditorModeManager.prototype = new TemplateEditorModeManager();

StickerEditorModeManager.prototype.afterUIEnable = function (data) {
  this.editor.canvas.runExtensions('enableRuler', {});
  this.editor.loadSvgString(
    Base64.decode(INKIVE.C.BLANK_SVG),
    _.bind(this.onBlankSVG, this, data),
    1000, 1000
  );
};

StickerEditorModeManager.prototype.onBlankSVG = function (data) {
  if (data.content) {
    let scale = Math.min(this.canvas.contentW, this.canvas.contentH);
    scale /= Math.max(data.width, data.height);

    INKIVE.DesignFacade.create('sticker', {
      sticker_id: data.id,
      thumb_src: data.url,
      banner: true,
      position: {
        x: (this.canvas.contentW - data.width * (scale / 2)) / 2,
        y: (this.canvas.contentH - data.height * (scale / 2)) / 2
      },
      size: {
        width: data.width * (scale / 2),
        height: data.height * (scale / 2)
      }
    });
  }
};

module.exports = StickerEditorModeManager;
